'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.checkValidSlug = checkValidSlug;
exports.isQiwiSlug = isQiwiSlug;
var TERMINAL = exports.TERMINAL = 'terminals_ru';
var QIWI_SLUG = exports.QIWI_SLUG = 'qiwi';
var SMS_SLUG = exports.SMS_SLUG = 'sms';
var ALFABANK_SLUG = exports.ALFABANK_SLUG = 'alfa';

function checkValidSlug(slug) {
    return isQiwiSlug(slug) || slug === SMS_SLUG || slug === ALFABANK_SLUG;
}

function isQiwiSlug(slug) {
    return slug.indexOf(QIWI_SLUG) === 0;
}


//////////////////
// WEBPACK FOOTER
// ./src/components/Order/paymentSlug.js
// module id = 1715
// module chunks = 0